module.exports = __webpack_public_path__ + "static/img/image1.2a1c7e4e.png";